<template>
  <div>
    <v-dialog
        v-model="dialog"
        scrollable
    >

      <v-card>
        <v-card-title v-if="tipo == 'mercadoria'">
          Mercadorias do cadastro
        </v-card-title>
        <v-card-text v-if="tipo == 'mercadoria'">
          <Mercadoria
              v-on:emitItem="selecionaElemento"
              is-used-into-another-view="timeline-modal-busca-mercadoria"
          ></Mercadoria>
        </v-card-text>

        <v-card-title v-if="tipo == 'tabela-preco'">
          Tabelas de Preços
        </v-card-title>
        <v-card-text v-if="tipo == 'tabela-preco'">
          <TabelaPrecoList
              v-on:emitItem="selecionaElemento"
              is-used-into-another-view
          ></TabelaPrecoList>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="secondary"
              @click="dialog = false"
          >
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <slot name="default" :open="openDialog">
      <v-btn
          @click="openDialog"
      >
<!--        use um slot p/ add o btn c/ icone-->
        ???
      </v-btn>
    </slot>

  </div>

</template>

<script>
import TabelaPrecoList from "../../tabela-preco/TabelaPrecoList";
import Mercadoria from "../../Mercadoria";
import {timelineMixin} from "../timelineMixin";
import ModelosCartaz from "./ModelosCartaz";

export default {
  name: "SelecionaElemento",
  mixins: [timelineMixin],
  props: {
    tipo: {
      type: String,
      required: true
    },
  },
  components: {ModelosCartaz, Mercadoria, TabelaPrecoList},
  data() {
    return {
      dialog: false,
      tab: null,
    }
  },
  methods: {
    openDialog() {
      this.dialog = true;
    },

    selecionaElemento(obj) {
      switch (this.tipo) {
        case 'mercadoria':
          this.$emit("emitItem", obj);
          break;

        case 'tabela-preco':
          this.$emit("emitItem", obj);
          break;
      }

      this.dialog = false;
    },
  },
}
</script>
